import React, { useEffect, useState } from "react";
import Image from "../../../../components/Image/Image";
import classes from "./DealsComp.module.css";
import { AccordionDetails, AccordionSummary } from "../../../../components";
import { Accordion } from "@mui/material";
import {
  convertByteToKb,
  convertFormat,
  filterTableValue,
} from "../../../../utils/helpers";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import IconComponent from "../../../../components/Icon/IconComponent";
import {
  ICON_LABELS,
  fontSize,
  fontWeight,
} from "../../../../utils/constants/UI";
import CustomMenu from "../../../../components/Menu/CustomMenu";
import { STRINGS } from "../../strings";
import { GREY } from "../../../../utils/constants/colors";
import IconColoredComponent from "../../../../components/Icon/IconColoredComponent";
import AttachmentDeleteModal from "./AttachmentDeleteModal";
import {
  CSV_IMAGE,
  DOC_IMAGE,
  INSERT_DRIVE_FILE,
  PDF_IMAGE,
  TXT_IMAGE,
  ZIP_IMAGE,
} from "../../../../utils/constants/assets";
import CustomTooltip from "../../../../components/Tooltip/CustomTooltip";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { EMITTER_ERROR } from "../../../../utils/constants";
import { getRequest } from "../../../../Apis";
import { useNavigate } from "react-router-dom";
import { crmEndpoints } from "../../../../utils/constants/httpConstants";
const ListingAttachmentDOcCard = ({
  attachmentDocList,
  deal_id,
  setAttachmentDocList,
  dealDetails,
}) => {
  const navigate = useNavigate();
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [isActionMenuVisible, setIsActionMenuVisible] = useState(false);
  const [attachmentOpen, setAttachmentOpen] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalDocAttachment, setTotalDocAttachment] = useState(0);
  const handleModal = (item, event) => {
    setData(item);
    setIsActionMenuVisible(true);
    setActionMenuAnchor(event.currentTarget);
  };

  const handleDownload = () => {
    window.open(data?.attachment_url, "_blank");
  };
  const tableOperations = [
    {
      id: STRINGS.SMALL_DELETE,
      label: STRINGS.DOWNLOAD,
      iconLabel: ICON_LABELS.ARROW_DOWN,
      function: () => handleDownload(),
    },
    {
      id: STRINGS.SMALL_DELETE,
      label: STRINGS.DELETE,
      iconLabel: ICON_LABELS.DELETE,
      function: () => handleDelete(),
      variant: "error",
    },
  ];

  const handleDelete = () => {
    setOpenDelete(true);
  };

  const getDocLogList = async (isOnScroll = false, count = 0, id) => {
    try {
      let url = `${
        crmEndpoints.getAttachments
      }/${deal_id}?file_extension=${"doc"}&page=${count}`;
      // !isOnScroll && setScreenLoading(true);
      const response = await getRequest(navigate, url);
      setTotalDocAttachment(response?.data?.data?.total_records);
      if (isOnScroll) {
        setAttachmentDocList([
          ...attachmentDocList,
          ...response?.data?.data?.records,
        ]);
      } else setTotalDocAttachment(response?.data?.data?.records);
      // !isOnScroll && setScreenLoading(false);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
      console.log("Error ->>>> ", error);
    }
  };
  const onScrollApiHandler = () => {
    const scrollableDiv =
      document?.getElementsByClassName("allDocAttachment")[0];
    const isAtBottom =
      scrollableDiv?.scrollTop >=
      scrollableDiv?.scrollHeight - scrollableDiv?.clientHeight;
    if (isAtBottom && totalDocAttachment > attachmentDocList?.length) {
      setPageCount(pageCount + 1);
      getDocLogList(true, pageCount + 1);
    }
  };

  useEffect(() => {
    if (dealDetails?.email?.length) {
      getDocLogList();
    }
  }, [dealDetails]);
  return (
    <div>
      <div
        className={`${classes.HeadAttachmentContainer} allDocAttachment`}
        id="comments_body"
        onScroll={onScrollApiHandler}
      >
        <Accordion
          className={classes.accrodionRoot}
          onChange={() => setAttachmentOpen(!attachmentOpen)}
          expanded={attachmentOpen}
        >
          <AccordionSummary
            className={classes.accordionSummary}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            {" "}
            <div className={classes.summaryContainerHeads}>
              <div className={classes.summaryContainerNote}>
                <div className={classes.summaryRightSection}>
                  <IconComponent
                    color={GREY.TERTIARY}
                    fontSize={fontSize.DXS}
                    iconLabel={
                      attachmentOpen
                        ? ICON_LABELS.ACTION_ARROW
                        : ICON_LABELS.KEYBOARD_ARROW_RIGHT
                    }
                  />

                  <IconColoredComponent
                    variant={"teal"}
                    iconLabel={ICON_LABELS.INSERT_DRIVE_FILE}
                    color={"teal"}
                    size="small"
                  />

                  <TypographyInline
                    label={"Documents"}
                    size={"sm"}
                    fontWeight={fontWeight.SEMIBOLD}
                    color={GREY.PRIMARY}
                  />
                </div>

                <div className={classes.dateTimeTaskContainer}>
                  <div
                    className={classes.moreOptionsIconContianer}
                    onClick={(e) => {
                      e?.stopPropagation();
                    }}
                  >
                    <CustomMenu
                      items={tableOperations}
                      anchor={actionMenuAnchor}
                      open={isActionMenuVisible}
                      onClose={() => {
                        setIsActionMenuVisible(false);
                        setActionMenuAnchor(null);
                      }}
                      paperMenuClass={classes.dropdownMenuListing}
                    />
                  </div>
                </div>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div
              className={
                attachmentDocList?.length
                  ? classes.AttachmentHeadScrollDetail
                  : ""
              }
              id="comments_body"
            >
              <div
                className={
                  attachmentDocList?.length ? classes.AttachmentHeadCon : ""
                }
              >
                {attachmentDocList?.map((item) => {
                  const DocExtension = item?.file_name?.split(".")[1];
                  return (
                    <div className={classes.AttachSubHeads}>
                      {DocExtension == "csv" ? (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={CSV_IMAGE} alt="" />
                        </div>
                      ) : DocExtension == "doc" ? (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={DOC_IMAGE} alt="" />
                        </div>
                      ) : DocExtension == "pdf" ? (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={PDF_IMAGE} alt="" />
                        </div>
                      ) : DocExtension == "txt" ? (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={TXT_IMAGE} alt="" />
                        </div>
                      ) : DocExtension == "zip" ? (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={ZIP_IMAGE} alt="" />
                        </div>
                      ) : (
                        <div className={classes.AttachmentDocUi}>
                          <Image src={INSERT_DRIVE_FILE} alt="" />
                        </div>
                      )}

                      <div className={classes.attachJustify}>
                        <CustomTooltip
                          title={
                            item?.file_name?.length >= 20 ? item?.file_name : ""
                          }
                        >
                          <div>
                            <TypographyInline
                              label={filterTableValue(item?.file_name)}
                              size={"sm"}
                              fontWeight={fontWeight.SEMIBOLD}
                              color={GREY.SECONDARY}
                            />
                            <div className={classes.paddingVerticalSize}>
                              {" "}
                              <TypographyInline
                                label={convertByteToKb(item?.content_length)}
                                size={"sm"}
                                fontWeight={fontWeight.REGULAR}
                                color={GREY.SECONDARY}
                              />
                              <div className={classes.verticalLineAttach} />
                              <TypographyInline
                                label={convertFormat(item?.created_at)}
                                size={"sm"}
                                fontWeight={fontWeight.REGULAR}
                                color={GREY.SECONDARY}
                              />
                            </div>
                          </div>
                        </CustomTooltip>
                        <IconComponent
                          color={GREY.TERTIARY}
                          fontSize={fontSize.MD}
                          iconLabel={ICON_LABELS.MORE_VERT}
                          onClick={(e) => handleModal(item, e)}
                        />
                      </div>
                    </div>
                  );
                })}
                {openDelete && (
                  <AttachmentDeleteModal
                    id={deal_id}
                    attachmentList={data}
                    openDelete={openDelete}
                    setOpenDelete={setOpenDelete}
                    setAttachmentList={setAttachmentDocList}
                  />
                )}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default ListingAttachmentDOcCard;
